import React from 'react';

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { BookingDetails } from '../../pages/dashboard/dashboardInterface';

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend);
const PieChart = ({ values }: { values: BookingDetails }) => {
  const data = {
    labels: ['Pending', 'Canceled', 'Confirmed'],
    datasets: [
      {
        label: 'Count',
        data: [
          values?.statusCounts?.PENDING,
          values?.statusCounts?.CANCELED,
          values?.statusCounts?.CONFIRMED,
        ],
        backgroundColor: ['#FFC62B', '#EB6F70', '#6BC497'],
        borderColor: ['#fff'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: '60%', // Controls doughnut thickness
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <Doughnut data={data} options={options} width={191.63} height={191.63} />
  );
};

export default PieChart;
